(() => {
  'use strict';
  const controls = form => [...(form?.elements || [])].filter(input => input.matches?.('[data-included-choice]'));
  const groups = form => [...new Set(controls(form).map(input => input.closest('[data-included-group]')))];
  function validate(form) {
    const missing = groups(form).find(group => !group.querySelector('[data-included-choice]:checked'));
    if (!missing) return true;
    missing.open = true;
    const input = missing.querySelector('input');
    input?.focus({ preventScroll: true });
    missing.scrollIntoView?.({ block: 'nearest', behavior: 'auto' });
    input?.reportValidity();
    return false;
  }
  document.addEventListener('invalid', event => {
    const group = event.target.closest?.('[data-included-group]');
    if (group) group.open = true;
  }, true);
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-included-choice]')) return;
    const group = event.target.closest('[data-included-group]');
    group.querySelector('[data-included-selection]').textContent = event.target.value;
    group.dataset.confirmed = 'true';
    const status = group.querySelector('[data-included-status]');
    if (status) status.textContent = 'Selected';
    group.open = false;
    const next = groups(event.target.form).find(item => !item.querySelector(':checked'));
    if (next) next.open = true;
    (next || group).querySelector('summary')?.focus({ preventScroll: true });
  });
  // Covers ordinary form submissions as well as AJAX entry points.
  document.addEventListener('submit', event => {
    if (!validate(event.target)) { event.preventDefault(); event.stopImmediatePropagation(); }
  }, true);
  window.NiralaIncludedOptions = { validate };
})();
